import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  Users,
  Award,
  BookOpen,
  Globe,
  Target,
  Calendar,
  Lightbulb,
  Network,
  GraduationCap,
  MessageSquare,
  TrendingUp,
  CheckCircle,
  ExternalLink,
  Search,
  Loader2,
  Filter,
  Video,
  ChevronDown,
  ChevronUp
} from 'lucide-react';

const CatedraHome = () => {
  const [catedraData, setCatedraData] = useState(null);
  const [isLoadingData, setIsLoadingData] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterPais, setFilterPais] = useState('');
  const [filterTipo, setFilterTipo] = useState('');
  const [showForo1, setShowForo1] = useState(false);
  const [searchTerm2, setSearchTerm2] = useState('');
  const [filterPais2, setFilterPais2] = useState('');

  useEffect(() => {
    const cargarDatos = async () => {
      try {
        const response = await fetch(`/data/catedra-home.json?v=${Date.now()}`);
        const data = await response.json();
        setCatedraData(data);
      } catch (error) {
        console.error('Error al cargar datos de Cátedra:', error);
      } finally {
        setIsLoadingData(false);
      }
    };

    cargarDatos();
  }, []);

  // Filtrar instancias colaboradoras
  const filteredInstancias = catedraData?.instanciasColaboradoras?.filter(instancia => {
    const matchSearch = searchTerm === '' ||
      instancia.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
      instancia.institucion.toLowerCase().includes(searchTerm.toLowerCase());

    const matchPais = filterPais === '' || instancia.pais === filterPais;
    const matchTipo = filterTipo === '' || instancia.tipo === filterTipo;

    return matchSearch && matchPais && matchTipo;
  }) || [];

  // Filtrar participantes segundo foro
  const filteredParticipantes2 = catedraData?.participantesSegundoForo?.filter(p => {
    const matchSearch = searchTerm2 === '' ||
      p.nombre.toLowerCase().includes(searchTerm2.toLowerCase()) ||
      p.ponente.toLowerCase().includes(searchTerm2.toLowerCase()) ||
      p.email.toLowerCase().includes(searchTerm2.toLowerCase());

    const matchPais = filterPais2 === '' || p.pais === filterPais2;

    return matchSearch && matchPais;
  }) || [];

  // Obtener listas únicas de países y tipos
  const paises = [...new Set(catedraData?.instanciasColaboradoras?.map(i => i.pais) || [])].sort();
  const paises2 = [...new Set(catedraData?.participantesSegundoForo?.map(i => i.pais) || [])].sort();
  const tipos = [...new Set(catedraData?.instanciasColaboradoras?.map(i => i.tipo) || [])].sort();

  const odsList = [
    { numero: 1, titulo: 'Fin de la pobreza' },
    { numero: 2, titulo: 'Hambre cero' },
    { numero: 3, titulo: 'Salud y bienestar' },
    { numero: 4, titulo: 'Educación de calidad' },
    { numero: 5, titulo: 'Igualdad de género' },
    { numero: 6, titulo: 'Agua limpia y saneamiento' },
    { numero: 7, titulo: 'Energía asequible y no contaminante' },
    { numero: 8, titulo: 'Trabajo decente y crecimiento económico' },
    { numero: 9, titulo: 'Industria, innovación e infraestructura' },
    { numero: 10, titulo: 'Reducción de las desigualdades' },
    { numero: 11, titulo: 'Ciudades y comunidades sostenibles' },
    { numero: 12, titulo: 'Producción y consumo responsables' },
    { numero: 13, titulo: 'Acción por el clima' },
    { numero: 14, titulo: 'Vida submarina' },
    { numero: 15, titulo: 'Vida de ecosistemas terrestres' },
    { numero: 16, titulo: 'Paz, justicia e instituciones sólidas' },
    { numero: 17, titulo: 'Alianzas para lograr los objetivos' }
  ];

  const actividadesFuturas = [
    { titulo: 'Publicaciones colectivas', descripcion: 'Difusión de información especializada' },
    { titulo: 'Postdoctorado en educación', descripcion: 'Programa especializado en Cátedras UNESCO' },
    { titulo: 'Jornada de Conversatorios', descripcion: 'Sobre educación de calidad / Cátedras UNESCO' },
    { titulo: 'Congreso virtual Iberoamericano', descripcion: 'Sobre IA en Análisis e Inclusión del Conocimiento' },
    { titulo: 'II Foro Iberoamericano', descripcion: 'De Cátedras UNESCO (mayo 2026)' }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-[#0077C8] via-[#005A9C] to-[#004B87] text-white py-20 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-20"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-6">
          {/* Logos Header */}
          <div className="bg-gradient-to-br from-white/95 to-white/90 rounded-2xl p-6 md:p-8 shadow-lg border border-white/30 mb-12 relative overflow-hidden backdrop-blur-sm">
            <div className="absolute inset-0 bg-gradient-to-r from-[#0077C8]/5 via-transparent to-[#0077C8]/5"></div>
            <div className="relative flex flex-col md:flex-row items-center justify-center gap-8 md:gap-14">
              {/* Logo Foro Iberoamericano */}
              <div className="group flex flex-col items-center">
                <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform group-hover:scale-105 border-2 border-transparent hover:border-[#0077C8]/20">
                  <img
                    src="https://catedra-unesco.cenid.org/images/logo_foro.jpg"
                    alt="Logo Foro Iberoamericano"
                    className="h-24 md:h-32 w-auto object-contain"
                  />
                </div>
                <span className="mt-3 text-sm font-semibold text-gray-700 group-hover:text-[#0077C8] transition-colors text-center">Foro Iberoamericano</span>
              </div>

              {/* Separator */}
              <div className="flex items-center justify-center">
                <div className="hidden md:flex flex-col items-center gap-2">
                  <div className="w-px h-12 bg-gradient-to-b from-transparent via-gray-400 to-transparent"></div>
                  <div className="bg-[#0077C8] p-2 rounded-full shadow-lg">
                    <Globe className="w-5 h-5 text-white" />
                  </div>
                  <div className="w-px h-12 bg-gradient-to-b from-gray-400 via-transparent to-transparent"></div>
                </div>
                <div className="md:hidden w-32 h-px bg-gradient-to-r from-transparent via-gray-400 to-transparent"></div>
              </div>

              {/* Logo Proyecto Cátedra */}
              <div className="group flex flex-col items-center">
                <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform group-hover:scale-105 border-2 border-transparent hover:border-[#0077C8]/20">
                  <img
                    src="https://recursos.cenid.org/img_cenid/proyecto_catedra.png"
                    alt="Proyecto Cátedra"
                    className="h-24 md:h-32 w-auto object-contain"
                  />
                </div>
                <span className="mt-3 text-sm font-semibold text-gray-700 group-hover:text-[#0077C8] transition-colors text-center">Proyecto Cátedra</span>
              </div>
            </div>
          </div>

          <div className="text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
              {isLoadingData ? (
                <Loader2 className="inline w-8 h-8 animate-spin" />
              ) : (
                catedraData?.titulo?.principal || 'Foro Iberoamericano de Cátedras UNESCO'
              )}
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 max-w-4xl mx-auto mb-8">
              {isLoadingData ? (
                <Loader2 className="inline w-4 h-4 animate-spin" />
              ) : (
                catedraData?.titulo?.subtitulo || 'Proyecto Cátedra sobre IA en Análisis e Inclusión del Conocimiento'
              )}
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-lg">
                <p className="text-2xl font-bold">
                  {isLoadingData ? (
                    <Loader2 className="inline w-4 h-4 animate-spin" />
                  ) : (
                    catedraData?.evento?.fechas || ''
                  )}
                </p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-lg">
                <p className="text-lg">
                  {isLoadingData ? (
                    <Loader2 className="inline w-4 h-4 animate-spin" />
                  ) : (
                    catedraData?.evento?.modalidad || 'Evento Virtual - YouTube'
                  )}
                </p>
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-lg flex items-center gap-2">
                  <Award className="w-5 h-5 text-yellow-300" />
                  <span className="text-lg font-semibold">Evento gratuito</span>
                </div>
                <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-lg flex items-center gap-2">
                  <CheckCircle className="w-5 h-5 text-green-300" />
                  <span className="text-lg font-semibold">Genera constancia de participación</span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-12">

        {/* Convocatoria */}
        <section className="mb-16">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-t-4 border-blue-600">
            <div className="p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3 justify-center text-center">
                <MessageSquare className="w-8 h-8 text-blue-600" />
                EL CENTRO DE ESTUDIOS E INVESTIGACIONES PARA EL DESARROLLO DOCENTE CENID, A.C.
              </h2>

              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3 justify-center text-center">
                CONVOCA
              </h2>

              <div className="space-y-6 text-gray-700 leading-relaxed">
                <p>
                  Se invita a las <strong>Cátedras UNESCO, redes, cuerpos académicos y grupos de investigación en Iberoamérica</strong> a participar en el Segundo Foro Iberoamericano de Cátedras UNESCO, que se llevará a cabo del{' '}
                  {isLoadingData ? (
                    <Loader2 className="inline w-4 h-4 animate-spin" />
                  ) : (
                    <strong>{catedraData?.evento?.fechas || ''}</strong>
                  )}
                  . Este evento tendrá como objetivo abrir un espacio de diálogo entre diversos actores sociales, incluyendo académicos e investigadores, servidores públicos, defensores de los derechos humanos y de la tierra, el sector privado, organizaciones no gubernamentales y la ciudadanía, con el fin de contribuir a la creación del <strong>Proyecto Cátedra sobre IA en Análisis e Inclusión del Conocimiento</strong>.
                </p>

                <p>
                  El propósito principal del encuentro es <strong>movilizar la inteligencia colectiva y la experiencia de las Cátedras UNESCO universitarias y las redes UNITWIN a nivel global</strong>, con el fin de intercambiar ideas sobre temas emergentes en el ámbito de la educación superior. A través de debates interdisciplinarios y multidisciplinarios, se busca expandir el conocimiento sobre cuestiones clave relacionadas con el mandato de la UNESCO en educación, cultura, comunicación y ciencias, así como los temas más amplios que son de interés para las Naciones Unidas, basándose en la experiencia e impacto de las Cátedras UNESCO de Iberoamérica en relación con la <strong>Agenda 2030 y los Objetivos de Desarrollo Sostenible (ODS)</strong>.
                </p>

                <div className="bg-blue-50 p-6 rounded-lg border-l-4 border-blue-600">
                  <h3 className="font-bold text-lg mb-3 text-blue-900">Meta del encuentro:</h3>
                  <p>
                    Apoyar y fortalecer la capacidad de acción en la región, promoviendo la inclusión, integración y complementariedad de iniciativas internacionales de intercambio de conocimiento.
                  </p>
                </div>

                <p>
                  Este segundo foro iberoamericano, se celebrará del{' '}
                  {isLoadingData ? (
                    <Loader2 className="inline w-4 h-4 animate-spin" />
                  ) : (
                    catedraData?.evento?.fechas || ''
                  )}
                  {' '}en el CENID, se realizará de manera virtual, transmitida a través de YouTube. Este evento busca ampliar las fronteras del conocimiento en torno a los temas relacionados con los mandatos de la UNESCO, abordando además cuestiones de interés más amplio para las Naciones Unidas y los ODS.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Sede e Información */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          <div className="bg-white rounded-xl shadow-lg p-6 border-t-4 border-[#0b742f] hover:shadow-xl transition-shadow duration-300">
            <div className="flex items-center gap-3 mb-3">
              <div className="bg-[#0b742f]/10 p-3 rounded-lg">
                <Globe className="w-6 h-6 text-[#0b742f]" />
              </div>
              <h3 className="text-lg font-bold text-gray-900">Sede</h3>
            </div>
            <p className="text-gray-600">Centro de Estudios e Investigaciones para el Desarrollo Docente A C (CENID)</p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 border-t-4 border-[#e87729] hover:shadow-xl transition-shadow duration-300">
            <div className="flex items-center gap-3 mb-3">
              <div className="bg-[#e87729]/10 p-3 rounded-lg">
                <Video className="w-6 h-6 text-[#e87729]" />
              </div>
              <h3 className="text-lg font-bold text-gray-900">Modalidad</h3>
            </div>
            <p className="text-gray-600">Virtual, transmitida a través de redes sociales y canal de YouTube</p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 border-t-4 border-blue-500 hover:shadow-xl transition-shadow duration-300">
            <div className="flex items-center gap-3 mb-3">
              <div className="bg-blue-500/10 p-3 rounded-lg">
                <Award className="w-6 h-6 text-blue-500" />
              </div>
              <h3 className="text-lg font-bold text-gray-900">Costo</h3>
            </div>
            <p className="text-gray-600 font-bold text-xl">Evento totalmente gratuito</p>
          </div>
        </div>


        {/* Participantes II Foro */}
        <section className="mb-16">
          <div className="bg-gradient-to-r from-[#0077C8] to-[#005A9C] text-white rounded-lg shadow-xl p-8">
            <div className="text-center mb-8">
              <h2 className="text-4xl font-bold mb-4">Participantes del II Foro Iberoamericano</h2>
              <p className="text-xl">Destacados ponentes y especialistas que nos acompañan en esta edición</p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="mb-6 space-y-4">
                <div className="flex flex-col md:flex-row gap-4">
                  <div className="relative flex-1">
                    <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-white/70" />
                    <input
                      type="text"
                      placeholder="Buscar por cátedra, ponente o correo..."
                      value={searchTerm2}
                      onChange={(e) => setSearchTerm2(e.target.value)}
                      className="w-full pl-12 pr-4 py-3 border-2 border-white/30 rounded-lg focus:outline-none focus:border-white focus:bg-white/10 transition-colors text-white placeholder:text-white/70 bg-white/10"
                    />
                  </div>
                  <div className="w-full md:w-64">
                    <select
                      value={filterPais2}
                      onChange={(e) => setFilterPais2(e.target.value)}
                      className="w-full px-4 py-3 border-2 border-white/30 rounded-lg focus:outline-none focus:border-white focus:bg-white/10 transition-colors text-white bg-white/10 h-full"
                    >
                      <option value="">Todos los países</option>
                      {paises2.map(pais => (
                        <option key={pais} value={pais}>{pais}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="flex items-center justify-between bg-white/10 px-4 py-2 rounded-lg">
                  <p className="text-sm text-white">
                    Mostrando <strong>{filteredParticipantes2.length}</strong> de <strong>{catedraData?.participantesSegundoForo?.length || 0}</strong> participantes
                  </p>
                </div>
              </div>

              {isLoadingData ? (
                <div className="flex justify-center items-center py-12">
                  <Loader2 className="w-8 h-8 text-white animate-spin" />
                </div>
              ) : filteredParticipantes2.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {filteredParticipantes2.map((p) => (
                    <div
                      key={p.id}
                      className="bg-white/10 border border-white/20 rounded-lg p-5 hover:bg-white/20 transition-all group"
                    >
                      <div className="flex items-start gap-4">
                        <div className="bg-white text-blue-600 p-2 rounded-lg group-hover:bg-blue-600 group-hover:text-white transition-colors">
                          <Users className="w-6 h-6" />
                        </div>
                        <div className="flex-1">
                          <h4 className="font-bold text-lg mb-1 leading-tight">{p.nombre}</h4>
                          <p className="text-white/90 font-medium mb-1">Ponente: {p.ponente}</p>
                          <div className="flex flex-wrap gap-2 items-center mt-2">
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-500 text-white">
                              {p.pais}
                            </span>
                            <span className="text-sm text-white/70 flex items-center gap-1">
                              <ExternalLink className="w-3 h-3" />
                              {p.email}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-12">
                  <Search className="w-12 h-12 text-white/30 mx-auto mb-4" />
                  <p className="text-white/80 text-lg">No se encontraron participantes que coincidan con la búsqueda</p>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Agenda 2030 y ODS */}
        <section className="mb-16">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-t-4 border-green-600">
            <div className="p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <Target className="w-8 h-8 text-green-600" />
                Agenda 2030 y Objetivos de Desarrollo Sostenible
              </h2>

              <div className="space-y-6">
                <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-6 rounded-lg">
                  <p className="text-gray-700 leading-relaxed">
                    La <strong>Agenda 2030 para el Desarrollo Sostenible</strong> es un compromiso global que incluye 17 ODS, que están interconectados y son indivisibles, abarcando las tres dimensiones del desarrollo sostenible: <strong>económica, social y ambiental</strong>. Estos ODS reflejan la naturaleza integral de la nueva Agenda Universal.
                  </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                  {odsList.map((ods) => (
                    <div
                      key={ods.numero}
                      className="bg-gradient-to-br from-green-50 to-teal-50 border border-green-200 rounded-lg p-4 hover:shadow-md transition-all"
                    >
                      <div className="flex items-start gap-3">
                        <div className="bg-green-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm flex-shrink-0">
                          {ods.numero}
                        </div>
                        <p className="text-sm font-medium text-gray-800 leading-tight">{ods.titulo}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Actividades Futuras 2026 */}
        <section className="mb-16">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-t-4 border-orange-600">
            <div className="p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <Calendar className="w-8 h-8 text-orange-600" />
                Actividades 2026
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {actividadesFuturas.map((actividad, index) => (
                  <div
                    key={index}
                    className="bg-gradient-to-br from-orange-50 to-amber-50 border border-orange-200 rounded-lg p-5 hover:shadow-lg transition-all"
                  >
                    <div className="flex items-start gap-3 mb-2">
                      <TrendingUp className="w-6 h-6 text-orange-600 flex-shrink-0" />
                      <h3 className="font-bold text-gray-900">{actividad.titulo}</h3>
                    </div>
                    <div
                      className="text-sm text-gray-700 ml-9"
                      dangerouslySetInnerHTML={{ __html: actividad.descripcion }}
                    />
                  </div>
                ))}
              </div>

              <div className="mt-8 bg-gradient-to-r from-orange-50 to-red-50 border-l-4 border-orange-600 p-6 rounded-lg">
                <p className="text-gray-700 leading-relaxed">
                  <strong>La continuidad dependerá del compromiso individual y colectivo de las cátedras</strong>, fomentando alianzas multidisciplinarias para diseñar proyectos coordinados en distintos territorios. Este es solo el inicio de un camino hacia la construcción de redes sólidas, capaces de materializar el legado de este encuentro.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Información de Inscripción al II Foro */}
        <section className="mb-16">
          <div className="bg-gradient-to-br from-[#0077C8] to-[#005A9C] rounded-lg shadow-2xl overflow-hidden">
            <div className="p-8 md:p-12">
              <div className="text-center mb-8">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 rounded-full mb-4">
                  <Users className="w-8 h-8 text-white" />
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                  {isLoadingData ? (
                    <Loader2 className="inline w-5 h-5 animate-spin" />
                  ) : (
                    catedraData?.inscripcion?.tituloSeccion || '¡Participa en el II Foro Iberoamericano!'
                  )}
                </h2>
                <p className="text-xl text-white/90 max-w-3xl mx-auto">
                  {isLoadingData ? (
                    <Loader2 className="inline w-4 h-4 animate-spin" />
                  ) : (
                    catedraData?.inscripcion?.descripcionSeccion || 'Regístrate ahora para formar parte de este importante evento'
                  )}
                </p>
              </div>

              {/* Información del Evento 
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 md:p-8 mb-8 border border-white/20">
                <h3 className="text-2xl font-bold text-white mb-6 text-center">
                  {isLoadingData ? (
                    <Loader2 className="inline w-5 h-5 animate-spin" />
                  ) : (
                    catedraData?.titulo?.principal || 'II Foro Iberoamericano de Cátedras UNESCO'
                  )}
                </h3>
                
                <div className="space-y-4">
                  <div className="flex items-center gap-4 bg-white/10 rounded-lg p-4">
                    <BookOpen className="w-6 h-6 text-white flex-shrink-0" />
                    <div>
                      <p className="text-white/80 text-sm">Proyecto</p>
                      <p className="text-white font-semibold">
                        {isLoadingData ? (
                          <Loader2 className="inline w-4 h-4 animate-spin" />
                        ) : (
                          catedraData?.titulo?.subtitulo || 'Cátedra sobre IA en Análisis e Inclusión del Conocimiento'
                        )}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-4 bg-white/10 rounded-lg p-4">
                    <Calendar className="w-6 h-6 text-white flex-shrink-0" />
                    <div>
                      <p className="text-white/80 text-sm">Fecha</p>
                      <p className="text-white font-semibold text-lg">
                        {isLoadingData ? (
                          <Loader2 className="inline w-4 h-4 animate-spin" />
                        ) : (
                          catedraData?.evento?.fechas || '6-8 de Mayo, 2026'
                        )}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-4 bg-white/10 rounded-lg p-4">
                    <Video className="w-6 h-6 text-white flex-shrink-0" />
                    <div>
                      <p className="text-white/80 text-sm">Modalidad</p>
                      <p className="text-white font-semibold">
                        {isLoadingData ? (
                          <Loader2 className="inline w-4 h-4 animate-spin" />
                        ) : (
                          catedraData?.evento?.modalidad || 'Evento Virtual - YouTube'
                        )}
                      </p>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="flex items-center gap-4 bg-white/10 rounded-lg p-4">
                      <Award className="w-6 h-6 text-yellow-300 flex-shrink-0" />
                      <div>
                        <p className="text-white font-semibold">Evento gratuito</p>
                      </div>
                    </div>

                    <div className="flex items-center gap-4 bg-white/10 rounded-lg p-4">
                      <CheckCircle className="w-6 h-6 text-green-300 flex-shrink-0" />
                      <div>
                        <p className="text-white font-semibold">Genera constancia de participación</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              */}


              {/* Botones de Acción */}
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link
                  to="/congresos/acceso?tipo=foro"
                  className="inline-flex items-center justify-center gap-3 bg-white text-[#0077C8] px-8 py-4 rounded-lg font-bold text-lg hover:shadow-xl transform hover:scale-105 transition-all"
                >
                  <Users className="w-6 h-6" />
                  Inscribirme al Foro
                </Link>

                <Link
                  to="/congresos/acceso?tipo=foro"
                  className="inline-flex items-center justify-center gap-3 bg-white/20 text-white border-2 border-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-white hover:text-[#0077C8] transition-all"
                >
                  <GraduationCap className="w-6 h-6" />
                  Recuperar mi acceso
                </Link>

                <a
                  href="https://congresos.cenid.org"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-3 bg-[#0b742f] text-white px-8 py-4 rounded-lg font-bold text-lg hover:shadow-xl transform hover:scale-105 transition-all hover:bg-[#085a24]"
                >
                  <ExternalLink className="w-6 h-6" />
                  Acceder a la Plataforma
                </a>
              </div>

              <div className="mt-6 text-center">
                <p className="text-white/80 text-sm">
                  {isLoadingData ? (
                    <Loader2 className="inline w-4 h-4 animate-spin" />
                  ) : (
                    catedraData?.inscripcion?.textoAyuda || '¿Ya tienes cuenta? Recupera tu contraseña para acceder a tu registro'
                  )}
                </p>
              </div>

              {/* Email para más información */}
              <div className="mt-6 text-center">
                <p className="text-white/80 text-lg">
                  {isLoadingData ? (
                    <Loader2 className="inline w-4 h-4 animate-spin" />
                  ) : (
                    `Para más información, contáctanos en: ${catedraData?.contacto?.email || 'correo no disponible'}`
                  )}
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Resultados I Foro (Colapsable) */}
        <section className="mb-8">
          <div className="bg-gradient-to-r from-gray-700 to-gray-800 text-white rounded-lg shadow-lg overflow-hidden transition-all duration-300">
            <button
              onClick={() => setShowForo1(!showForo1)}
              className="w-full flex items-center justify-between p-6 hover:bg-black/10 transition-colors"
            >
              <div className="flex items-center gap-4">
                < Award className="w-8 h-8 text-yellow-400" />
                <div className="text-left">
                  <h2 className="text-2xl font-bold">I Foro Iberoamericano - Resultados</h2>
                  <p className="text-gray-300 text-sm">Ver detalles y estadísticas del encuentro anterior</p>
                </div>
              </div>
              {showForo1 ? <ChevronUp className="w-6 h-6" /> : <ChevronDown className="w-6 h-6" />}
            </button>

            <div className={`transition-all duration-500 ease-in-out ${showForo1 ? 'max-h-[5000px] opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`}>
              <div className="p-8 pt-0 border-t border-white/10 mt-2">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 pt-6">
                  <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center">
                    <Users className="w-12 h-12 mx-auto mb-3" />
                    <p className="text-5xl font-bold mb-2">350</p>
                    <p className="text-lg">Asistentes</p>
                  </div>
                  <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center">
                    <MessageSquare className="w-12 h-12 mx-auto mb-3" />
                    <p className="text-5xl font-bold mb-2">21</p>
                    <p className="text-lg">Conferencistas Magistrales</p>
                  </div>
                </div>

                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
                  {/* Instancias Colaboradoras */}
                  <div className="mb-0">
                    <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3">
                      <Network className="w-7 h-7 text-white" />
                      Instancias colaboradoras
                    </h3>
                    {/* Buscador y Filtros */}
                    <div className="mb-6 space-y-4">
                      {/* Barra de búsqueda */}
                      <div className="relative">
                        <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-white/70" />
                        <input
                          type="text"
                          placeholder="Buscar por nombre o institución..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          className="w-full pl-12 pr-4 py-3 border-2 border-white/30 rounded-lg focus:outline-none focus:border-white focus:bg-white/10 transition-colors text-white placeholder:text-white/70 bg-white/10"
                        />
                      </div>

                      {/* Filtros */}
                      <div className="flex flex-col sm:flex-row gap-4">
                        <div className="flex-1">
                          <label className="block text-sm font-medium text-white mb-2 flex items-center gap-2">
                            <Filter className="w-4 h-4" />
                            Filtrar por país
                          </label>
                          <select
                            value={filterPais}
                            onChange={(e) => setFilterPais(e.target.value)}
                            className="w-full px-4 py-2 border-2 border-white/30 rounded-lg focus:outline-none focus:border-white focus:bg-white/10 transition-colors text-white bg-white/10"
                          >
                            <option value="">Todos los países</option>
                            {paises.map(pais => (
                              <option key={pais} value={pais}>{pais}</option>
                            ))}
                          </select>
                        </div>

                        <div className="flex-1">
                          <label className="block text-sm font-medium text-white mb-2 flex items-center gap-2">
                            <Filter className="w-4 h-4" />
                            Filtrar por tipo
                          </label>
                          <select
                            value={filterTipo}
                            onChange={(e) => setFilterTipo(e.target.value)}
                            className="w-full px-4 py-2 border-2 border-white/30 rounded-lg focus:outline-none focus:border-white focus:bg-white/10 transition-colors text-white bg-white/10"
                          >
                            <option value="">Todos los tipos</option>
                            {tipos.map(tipo => (
                              <option key={tipo} value={tipo}>{tipo}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    {/* Lista de instancias */}
                    {isLoadingData ? (
                      <div className="flex justify-center items-center py-12">
                        <Loader2 className="w-8 h-8 text-white animate-spin" />
                      </div>
                    ) : filteredInstancias.length > 0 ? (
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {filteredInstancias.map((instancia) => (
                          <div
                            key={instancia.id}
                            className="bg-white/10 border border-white/20 rounded-lg p-4 hover:bg-white/20 transition-all"
                          >
                            <div className="flex items-start gap-3">
                              <Award className="w-5 h-5 text-white flex-shrink-0 mt-0.5" />
                              <div className="flex-1">
                                <p className="text-sm font-semibold text-white leading-snug mb-1">
                                  {instancia.nombre}
                                </p>
                                <p className="text-xs text-white/80">{instancia.institucion}</p>
                                <div className="flex items-center gap-2 mt-2">
                                  <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-white/20 text-white">
                                    {instancia.pais}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center py-12">
                        <Search className="w-12 h-12 text-white/30 mx-auto mb-4" />
                        <p className="text-white/80 text-lg">No se encontraron instancias</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section>
          <div className="bg-gradient-to-r from-[#0077C8] to-[#005A9C] text-white rounded-lg shadow-xl p-8 text-center">
            <Lightbulb className="w-16 h-16 mx-auto mb-4" />
            <h2 className="text-3xl font-bold mb-4">Únete a la Red de Cátedras UNESCO</h2>
            <p className="text-xl mb-6 max-w-3xl mx-auto">
              Participa en la construcción de una comunidad iberoamericana comprometida con el desarrollo sostenible y la transformación educativa
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/catedra-unesco/quienes-somos"
                className="inline-flex items-center gap-2 bg-white text-[#0077C8] px-8 py-4 rounded-lg font-bold text-lg hover:shadow-xl transform hover:scale-105 transition-all"
              >
                <BookOpen className="w-6 h-6" />
                Conocer más
              </Link>
              <Link
                to="/catedra-unesco/proyectos"
                className="inline-flex items-center gap-2 bg-white/20 text-white border-2 border-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-white hover:text-[#0077C8] transition-all"
              >
                <Target className="w-6 h-6" />
                Ver Proyectos
              </Link>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
};

export default CatedraHome;
